import React, { useEffect, useState, useContext } from 'react';
import { Spinner } from 'components/Icons';
import { AuthContext, get_csv_export } from 'components';
import { Tracking } from 'components/Tracking';
import { SideNavItem } from 'layouts/portal/side-nav-item';
import { Modal, Button, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography } from '@mui/material';
import Papa from 'papaparse';
import { BorderAll as BorderAllIcon } from '@mui/icons-material';

export const CsvTable = ({ onClose }) => {
  const [ data, setData ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ open, setOpen ] = useState(false);
  const [ bugdetPreviewURL, setBugdetPreviewURL ] = useState(false);
  const { selectedSeason, selectedStore, accountBudgets, selectedSeasonitems, notify } = useContext(AuthContext);

  useEffect(() => {
    if (open) {
      handleOpen()
    } else {
      setData([])
      setBugdetPreviewURL(false)
    }
  }, [selectedSeason, selectedStore, accountBudgets, selectedSeasonitems])

  const handleOpen = () => {
    setOpen(true);
    Tracking.track('Portal - Order report')
    
    if (!bugdetPreviewURL) {
      setLoading(true);
      get_csv_export({
        season: selectedSeason,
        storeId: selectedStore,
        noMail: true,
      }).then((data) => {
        setLoading(false)
        setBugdetPreviewURL(data?.data?.download_url);
      }).catch((error) => {
        console.log('error', error)
        setLoading(false);
        notify({ message: 'An error occurred when generating the report. Please try again later or contact support@thefavesapp.com for assistance.', variant: 'error' });
      });
    }
  }

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
    setOpen(false);
  }

  useEffect(() => {
    if (bugdetPreviewURL) {
      Papa.parse(bugdetPreviewURL, {
        header: true,
        download: true,
        complete: (results) => {
          setData(results.data);
          setLoading(false);
        },
        error: (err) => {
          setError(err.message);
          setLoading(false);
        }
      });
    }
  }, [bugdetPreviewURL]);

  return (
    <>
      <SideNavItem
        onClick={handleOpen}
        active={false}
        external={false}
        disabled={false}
        icon={<BorderAllIcon fontSize="small"/>}
        key={`sidenavitem-order-report`}
        title={'Order Report'}
      />
      <Modal open={open} onClose={handleClose}>
        <TableContainer className='csv-preview' component={Paper} style={{ padding: '20px', margin: 'auto', width: '98%', height: '100%', overflow: 'scroll', whiteSpace: 'pre' }}>
          <Button onClick={handleClose} variant="outlined" color="secondary" style={{ marginRight: '20px' }}>
            Close
          </Button>
          <Button disabled={!bugdetPreviewURL} color="secondary" variant='contained' onClick={() => {
            window.open(bugdetPreviewURL, '_blank')?.focus();
          }}>Download</Button>
            {loading ? (
              <Spinner/>
            ) : (
            <>
              <Typography sx={{m: 2, ml: 0}} variant='h3'>Order Report</Typography>
              <Table>
                <TableBody>
                  {data.slice(1).map((row, index) => {
                    return (
                      <TableRow sx={{
                        '&:nth-of-type(even)': {
                          background: '#eeeeee'
                        }
                      }} key={`csv-table-table-row-${index}`}>
                        {Object.values(row).map((cell, index) => {
                          if (typeof cell === 'string') {
                            return (
                              <TableCell key={`cell-single-${index}`}>{cell}</TableCell>
                            )
                          }

                          return (
                            <>
                              {cell?.map((c, i) => (
                                <TableCell key={`cell-multi-${index}-${i}`}>{c}</TableCell>
                              ))}
                            </>
                          )
                        })}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </>
          )}
        </TableContainer>
      </Modal>
    </>
  );
};
